import { IQuery, useFirebaseData } from '../../@shared/hooks/useFirebaseData';
import { Collections } from '../../@core/constants/FirebasePaths';
import { Queries } from '../../@core/constants/Queries';
import { IReservation } from '../../@core/interfaces/IReservation';
import { useFirebasePopulate } from '../../@shared/hooks/useFirebasePopulate';

interface useReservationsProps {
  loadData?: boolean;
  queries?: IQuery[];
  id?: string;
}

export const useReservations = ({ loadData = false, queries = [], id }: useReservationsProps) => {
  const { populateItems, populateItem } = useFirebasePopulate()
  const db = useFirebaseData<IReservation>({
    collectionPath: id ? `${Collections.reservations._path}/${id}` : Collections.reservations._path,
    loadData,
    queries: [...queries, ...Queries.trash],
    initialPopulate: {
      fields: ['createdBy', 'order']
    }
  })

  const getReservations = async (queries: IQuery[] = []): Promise<IReservation[]> => {
    const reservations = await db.collectionWithIds([...queries, ...Queries.trash]);
    return await populateItems(reservations, ['createdBy', 'order']) as IReservation[]
  }

  const updateReservation = async (id: string, data: Partial<IReservation>) => {
    return await db.update(id, data);
  }

  const getReservationById = async (id: string): Promise<IReservation | null> => {
    const res = await db.docWithId(`${Collections.reservations._path}/${id}`)
    return await populateItem(res, ['createdBy', 'order']) as IReservation
  }

  return {
    reservations: db.data,
    getReference: db.getReference,
    getReservations,
    updateReservation,
    getReservationById
  }
}
